<template>
  <div>
    <media-registration  v-on:updateComplete="updateComplete" :area-seq="search.areaSeq" :store-seq="search.storeSeq" is-detail="edit" :advertisement-seq="search.advertisementSeq"></media-registration>

    <media-registration :area-seq="search.areaSeq" :store-seq="search.storeSeq" is-detail="pre" :advertisement-seq="search.advertisementSeq"></media-registration>
  </div>
</template>

<script>
  import Vue from 'vue'

  import MediaRegistration from "../Media/MediaRegistration";

    export default {
      name: "MediaEditPage",
      components: {
        MediaRegistration,
      },
      beforeCreate: function () {
        $cookies.set('id_token', this.$route.query.id_token);
        this.$store.dispatch('auth/check');
      },
      created: function () {
        this.search.storeSeq = this.$route.params.storeSeq;
        this.search.advertisementSeq = this.$route.params.advertisementSeq;
        this.search.areaSeq = this.$route.query.area_seq;
        this.search.page = this.$route.query.page;
      },
      methods: {
        updateComplete() {
          if(this.search.page === "store") {
            window.opener.updateCompleteStore();
          } else {
            window.opener.updateComplete();
          }
        },
      },
      data() {
        return {
          search: {
            areaSeq: '',
            storeSeq: '',
            advertisementSeq: '',
            page: '',
          },
        }
      }
    }
</script>

<style>
  .el-input.is-disabled .el-input__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #606266 !important;
    cursor: not-allowed;
  }
  .el-radio-button__orig-radio:disabled+.el-radio-button__inner {
    color: #606266;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;
    -webkit-box-shadow: none;
    box-shadow: none;
  }


</style>
